import { STANDARD_APPLIED, STANDARD_SELECTED } from '../StandardsSelector';

/**
 * Compares two confidence ratings for sorting
 * @param {number|null} ratingA - First confidence rating
 * @param {number|null} ratingB - Second confidence rating
 * @returns {number} Sort comparison result
 */
export function compareConfidenceRatings (ratingA, ratingB) {
  // Ensure we're comparing numbers
  const numRatingA = typeof ratingA === 'number' ? ratingA : null;
  const numRatingB = typeof ratingB === 'number' ? ratingB : null;

  // If both have valid confidence ratings, sort by rating (descending)
  if (numRatingA !== null && numRatingB !== null) {
    return numRatingB - numRatingA;
  }

  // If only one has a valid confidence rating, prioritize the one with rating
  if (numRatingA !== null && numRatingB === null) return -1;
  if (numRatingA === null && numRatingB !== null) return 1;

  // If neither has a confidence rating, maintain original order
  return 0;
}

/**
 * Sorts standards by confidence rating (higher first)
 * @param {Array} standards - Array of standards to sort
 * @returns {Array} Sorted array of standards
 */
export function sortByConfidenceRating (standards) {
  return standards.sort((a, b) => compareConfidenceRatings(a.confidenceRating, b.confidenceRating));
}

/**
 * Sorts categorized standards with applied standards first, then by confidence rating
 * @param {Array} standards - Array of standards with __temporaryStatus
 * @returns {Array} Sorted array of standards
 */
export function sortCategorizedStandards (standards) {
  return standards.sort((a, b) => {
    // First priority: applied standards come before selected standards
    if (a.__temporaryStatus === STANDARD_APPLIED && b.__temporaryStatus === STANDARD_SELECTED) return -1;
    if (a.__temporaryStatus === STANDARD_SELECTED && b.__temporaryStatus === STANDARD_APPLIED) return 1;

    // Second priority: for selected standards, sort by confidence rating (higher first)
    if (a.__temporaryStatus === STANDARD_SELECTED && b.__temporaryStatus === STANDARD_SELECTED) {
      return compareConfidenceRatings(a.confidenceRating, b.confidenceRating);
    }

    // For applied standards, maintain original order
    return 0;
  });
}
